<template lang="pug">
.change-record-container(v-if="show")
  .shadow(@click="closeModal")
  .change-record
    .no-use-top(@click="closeModal")
      img.no-use-close(src="https://m.hellobike.com/resource/gallery/61/__G7W1L7To.png?x-oss-process=image/quality,q_80" @click="closeModal")
    .change-record-title 券的变更记录
    .change-item-list(v-if="list.length>0")
      changeItem.chang-item(v-for="item in list" :groups="item")
    .ride-no-card(v-else)
      .no-img
        img(src="https://m.hellobike.com/resource/gallery/61/BxqbUTMW4e.png?x-oss-process=image/quality,q_80")
      .no-word 暂无变更记录
  </template>
<script>
import {
  getTokenAndKey,
} from '@/utils';
import {
  queryTransitionRecord,
} from '@/api/vip';
import changeItem from './change-item.vue';
import { CouponMapper } from '../utils';

export default {
  components: {
    changeItem,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    vipRecordGuid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.getData();
      }
    },
  },
  destroyed() {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false);
    },
    async getData() {
      const { token } = await getTokenAndKey();
      try {
        const res = await queryTransitionRecord({
          token,
          vipRecordGuid: this.vipRecordGuid,
        });
        if (res.data) {
          this.list = res.data.propTransRecordInfoList || [];
          if (this.list.length > 0) {
            this.list.forEach((i) => {
            // eslint-disable-next-line no-param-reassign
              i.afterProperty = CouponMapper(i.afterProperty);
              // eslint-disable-next-line no-param-reassign
              i.beforeProperty = CouponMapper(i.beforeProperty);
            });
          }
        }
        // eslint-disable-next-line no-empty
      } catch { }
    },
  },
};
</script>
<style lang="less" scoped>
.change-record-container {
  position: fixed;
  bottom: 0;
  z-index: 222;
  width: 100%;

  .change-record {
    background: linear-gradient(180deg, #fce38a 0%, #fff 5.56%);
    box-shadow: 0 0.01rem 0.05rem 0 rgba(255, 255, 255, 0.27);
    border-radius: 0.05rem 0.05rem 0 0;
    position: relative;
    z-index: 223;
    height: 4.04rem;
    padding-top: 0.19rem;

    .no-use-top {
      img.no-use-close {
        position: absolute;
        top: 0.087rem;
        right: 0.067rem;
        height: 0.23rem;
        width: 0.23rem;
      }
    }

    .change-record-title {
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.16rem;
      font-weight: 600;
      line-height: 0.22rem;
      text-align: center;
      color: #6f2500;
    }

    .change-item-list {
      overflow-y: scroll;
      padding: 0 0.22rem;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      flex: 1;
      width: 100%;

      .chang-item {
        margin-top: 0.2rem;
      }
    }

    .ride-no-card {
      margin-top: 0.2rem;
      padding: 0 0.27rem 0 0.25rem;

      .no-img {
        margin: 0.53rem auto 0 auto;
        display: flex;
        justify-content: center;

        img {
          margin: 0 auto;
          width: 1.6rem;
          height: 1.25rem;
        }
      }

      .no-word {
        margin-top: 0.16rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        ;
        font-size: 0.16rem;
        font-weight: 400;
        line-height: 0.224rem;
        text-align: center;

      }
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 100;
  }
}
</style>
